/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, {Component} from 'react';

// import { FontSizeChanger } from 'react-font-size-changer';
// import { connect } from 'react-redux';
import {connect} from 'react-redux';

import * as setupActions from '@/actions/setupActions';
import {Post} from '@/api/request';
import ToggleButton from '@/components/togglebutton/ToggleButton';
import * as APPDATA from '@/constants/pcConstAppData';

import '../../../styles/variable.less';
import BottomMenu from '../../menu/bottommenu/BottomMenu';

import './DisplaySetting.scss';

@connect((store) => ({
  fontSize: store.setupStore.fontSize,
  // topButtonProperties: store.setupStore.topButtonProperties,
}))
class DisplaySetting extends Component {
  constructor(props) {
    super(props);
    // Initiate state for this component
    this.state = {
      fontSizeValue: 1,
      isButtonBackPopUp: false,
    };
    this.successUpdateFontSize = this.successUpdateFontSize.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(setupActions.updateActiveMenu(APPDATA.DISPLAY_SETTING));
    this.setTopMenuProperties();
    this.setFontSize();
  }

  setTopMenuProperties = () => {
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: this.backAction,
    };
    const titleMenuProperties = APPDATA.SYSTEM_SETTING;
    this.setupTopMenuProperties(undefined, backButtonProperties, titleMenuProperties);
  };

  setupTopMenuProperties = (topButtonProperties, backButtonProperties, titleMenuProperties) => {
    this.props.dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
      }),
    );
    this.props.dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };

  // eslint-disable-next-line react/sort-comp
  backAction = () => {
    // if (this.state.isButtonBackPopUp === false) {
    this.goToHomeScreen();
    // }
    // else {
    //     var popUpButton = [{
    //         id: APPDATA.YES,
    //         isPrimaryButton: true,
    //         onClick: this.onClickPopUpBackButton,
    //         label: APPDATA.YES
    //     },
    //     {
    //         id: APPDATA.NO,
    //         isPrimaryButton: false,
    //         onClick: this.onClickPopUpBackButton,
    //         label: APPDATA.NO
    //     }
    //     ]
    //     this.props.dispatch(modalActions.showPopUp({
    //         popUpTitle: "Display Setting",
    //         popUpText: <div>{"You are about to exit Display setting."}<br />{"Do you want to continue?"}</div>,
    //         popUpQuestion: undefined,
    //         popUpButton: popUpButton,
    //     }))
    // }
  };

  //   onClickPopUpBackButton = (e) => {
  //     switch (e.currentTarget.id) {
  //       case APPDATA.YES:
  //         this.goToHomeScreen();
  //         break;
  //       case APPDATA.NO:
  //         break;
  //       default:
  //         break;
  //     }
  //     this.props.dispatch(modalActions.hidePopUp());
  //   };

  // eslint-disable-next-line class-methods-use-this
  goToHomeScreen = () => {
    window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
  };

  setFontSize() {
    let fontSizeValue;
    switch (this.props.fontSize) {
      case APPDATA.SMALL_FONT_SIZE:
        fontSizeValue = 1;
        break;
      case APPDATA.MEDIUM_FONT_SIZE:
        fontSizeValue = 2;
        break;
      case APPDATA.LARGE_FONT_SIZE:
        fontSizeValue = 3;
        break;
      default:
        break;
    }
    this.setState({
      fontSizeValue,
    });
  }

  updateFont = (e) => {
    let newFontSize = 0;
    switch (e.currentTarget.id) {
      case APPDATA.SMALL:
        newFontSize = APPDATA.SMALL_FONT_SIZE;
        break;
      case APPDATA.MEDIUM:
        newFontSize = APPDATA.MEDIUM_FONT_SIZE;
        break;
      case APPDATA.LARGE:
        // newFontSize = APPDATA.MEDIUM_FONT_SIZE;
        // break;
        newFontSize = APPDATA.LARGE_FONT_SIZE;
        break;
      default:
        break;
    }
    window.localStorage.setItem(APPDATA.FONT_SIZE, newFontSize);
    const param = {
      [APPDATA.KEY.FontSize]: newFontSize.toString(),
    };

    Post(APPDATA.API.DISPLAY_SETTINGS, param, this.successUpdateFontSize);
    this.state.isButtonBackPopUp = true;
  };

  successUpdateFontSize = (response) => {
    this.props.dispatch(setupActions.updateFontSize(response.data[APPDATA.KEY.FontSize]));
  };

  render() {
    const fonstSizeButtonProp = [
      {
        label: APPDATA.SMALL,
        value: 1,
        onClick: this.updateFont,
      },
      // {
      //     label: APPDATA.LARGE,
      //     value: 2,
      //     onClick: this.updateFont,
      // },
      {
        label: APPDATA.MEDIUM,
        value: 2,
        onClick: this.updateFont,
      },
      {
        label: APPDATA.LARGE,
        value: 3,
        onClick: this.updateFont,
      },
    ];

    const style = {
      constraint: {
        fontSize: this.props.fontSize,
      },
    };
    return (
      <div style={style.constraint}>
        <div className="row rowHeight middleAlign">
          <div className="col-sm-5">
            <ToggleButton
              label={APPDATA.FONT_SIZE}
              buttonProp={fonstSizeButtonProp}
              defaultValue={1}
              value={this.state.fontSizeValue}
              onClick={this.updateFont}
            />
          </div>
        </div>
        <BottomMenu />
      </div>
    );
  }
}
export default DisplaySetting;
